import { graphql } from "gql";

const INTERNAL_ADMIN_EDIT_TAG_MUTATION = graphql(`
  mutation InternalAdminEditTag(
    $organizationId: ID!
    $id: ID!
    $input: AdminEditTagInput!
  ) {
    internalAdminEditTag(
      organizationId: $organizationId
      id: $id
      input: $input
    ) {
      ...InternalAdminTag
    }
  }
`);

export default INTERNAL_ADMIN_EDIT_TAG_MUTATION;
